import { createReducer } from '@reduxjs/toolkit';
import { switchAccountSuccess } from 'store/account/actions';
import * as actions from '../actions';

export interface AuthenticatePinState {
  isFetching: boolean;
  error: null | Error;
  data: null | AuthenticatePinData;
}

export interface Guarantor {
  mmi: number;
}

export interface AuthenticatePinData {
  jwtToken: string;
  guarantor: Guarantor;
}

export const authenticatePinInitialState: AuthenticatePinState = {
  isFetching: false,
  error: null,
  data: null
};

const authenticatePinReducer = createReducer(authenticatePinInitialState, {
  [actions.WEBPAY_AUTHENTICATE]: state => {
    state.isFetching = true;
    state.error = null;
  },
  [actions.WEBPAY_AUTHENTICATE_SUCCESS]: (state, action) => {
    state.isFetching = false;
    state.data = action.payload.data;
  },
  [actions.WEBPAY_AUTHENTICATE_FAIL]: (state, action) => {
    state.isFetching = false;
    state.data = null;
    state.error = action.error;
  },
  [switchAccountSuccess.type]: () => authenticatePinInitialState
});

export default authenticatePinReducer;
